import { render, staticRenderFns } from "./reset.vue?vue&type=template&id=58c7307f"
import script from "./reset.vue?vue&type=script&lang=js"
export * from "./reset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Field: require('/vercel/path0/components/ui/field.vue').default,PrimaryButton: require('/vercel/path0/components/ui/primaryButton.vue').default})
